import { render } from "./FacilityOfficeSplitChart.vue?vue&type=template&id=7fb0f7e4&scoped=true"
import script from "./FacilityOfficeSplitChart.vue?vue&type=script&lang=js"
export * from "./FacilityOfficeSplitChart.vue?vue&type=script&lang=js"

import "./FacilityOfficeSplitChart.vue?vue&type=style&index=0&id=7fb0f7e4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7fb0f7e4"

export default script